import { useMediaQuery } from 'react-responsive'

export const useDevice = () => {
	const isMobileOrTablet = useMediaQuery({
		query: '(max-width: 767px)'
	})

	const isMobileOrTabletHorizontal = useMediaQuery({
		query: '(max-width: 1023px)'
	})

	const isBelowDesktop = useMediaQuery({
		query: '(max-width: 1279px)'
	})

	return {
		isMobileOrTablet,
		isMobileOrTabletHorizontal,
		isBelowDesktop
	}
}
